<!-- 嵌入式-维修处理 -->
<template>
  <el-card>
    <div class="toolbar">
      <div class="former">
        <el-input
          v-model.trim="key"
          placeholder="名称、SN或送修来源"
          @keydown.enter.native="onSubmitQuery"
        >
        </el-input
        >&nbsp;
        <el-select v-model="former.Type" clearable placeholder="维修类型">
          <el-option label="产品" :value="0"></el-option>
          <el-option label="配件" :value="1"></el-option> </el-select
        >&nbsp;
        <select2
          labelName="Name"
          v-model="former.DealPeopleID"
          url="user"
          clearable
          placeholder="处理人"
          no-data-text="没有处理人"
        ></select2
        >&nbsp;
        <select2
          labelName="Value"
          valueKey="Key"
          v-model="former.DealStatus"
          url="dci/maintain/status-list"
          clearable
          placeholder="维修状态"
          no-data-text="没有维修状态"
          :currentList="curStatus"
        ></select2
        >&nbsp;
        <el-button type="primary" @click="onSubmitQuery">
          <i class="fas fa-search"></i>
        </el-button>
      </div>
    </div>
    <el-table :data="itemList" v-loading="loading" size="medium">
      <el-table-column
        type="index"
        :index="pager.size * (pager.page - 1) + 1"
        :width="Math.max(40, (pager.size * pager.page).toString().length * 12)"
      />
      <el-table-column label="类型" width="70">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.Type === 0" type="warning"> 产品 </el-tag>
          <el-tag v-if="scope.row.Type === 1" type="success"> 配件 </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="产品/配件型号名称" width="200" >
        <template slot-scope="scope">
          <div v-if="scope.row.DciProduct !== null">
            {{ scope.row.DciProduct.DciProductModel.NameNumber }}
          </div>
          <div v-if="scope.row.DciAccessory !== null">
            {{ scope.row.DciAccessory.DciAccessoryModel.NameNumber }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="产品/配件SN" width="190">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.DciProduct !== null">
            {{ scope.row.DciProduct.SN }}
          </el-tag>
          <el-tag type="success" v-if="scope.row.DciProduct !== null && scope.row.DciProduct.Remark !== ''">
            {{ scope.row.DciProduct.Remark }}
          </el-tag> 
          <el-tag v-if="scope.row.DciAccessory !== null">
            {{ scope.row.DciAccessory.SN }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="SendSource" label="送修来源" />
      <el-table-column label="送修日期" width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.SendAt">
            {{ $sys.dateFormat(scope.row.SendAt, "Y-m-d") }}
          </div>
        </template>
      </el-table-column>
      <el-table-column width="140">
        <template slot="header" slot-scope="scope">
          <div style="padding-left: 0px;padding-right: 0px;line-height: normal;">期望初检完成日期</div>
          <div style="padding-left: 0px;padding-right: 0px;line-height: normal;margin-top: -5px;">期望维修完成日期</div>
        </template>
        <template slot-scope="scope">
          <div
            v-if="
              scope.row.ExpectedInspectAt &&
              new Date(scope.row.ExpectedInspectAt).getTime() <=
                new Date(new Date()).getTime() &&
              (scope.row.DealStatus === 0 ||
                scope.row.DealStatus === 1 ||
                scope.row.DealStatus === 2)
            "
            style="color: red"
          >
            {{ $sys.dateFormat(scope.row.ExpectedInspectAt, "Y-m-d H:i") }}
          </div>
          <div v-else-if="scope.row.ExpectedInspectAt">
            {{ $sys.dateFormat(scope.row.ExpectedInspectAt, "Y-m-d H:i") }}
          </div>
          <div
            v-if="
              scope.row.ExpectedDealAt &&
              new Date(scope.row.ExpectedDealAt).getTime() <=
                new Date(new Date()).getTime() &&
              scope.row.DealStatus !== 6
            "
            style="color: red"
          >
            {{ $sys.dateFormat(scope.row.ExpectedDealAt, "Y-m-d H:i") }}
          </div>
          <div v-else-if="scope.row.ExpectedDealAt">
            {{ $sys.dateFormat(scope.row.ExpectedDealAt, "Y-m-d H:i") }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="更换方式" width="90">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.ReplacementMode === 0" type="warning">
            不更换
          </el-tag>
          <el-tag v-if="scope.row.ReplacementMode === 1" type="primary">
            更换配件
          </el-tag>
          <el-tag v-if="scope.row.ReplacementMode === 2" type="info">
            更换整机
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="DealPeople.Name" label="处理人" width="70" />
      <el-table-column prop="DealStatusName" label="维修状态" width="105">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.DealStatus === 4" type="warning">
            {{ scope.row.DealStatusName }}
          </el-tag>
          <el-tag v-else type="success">
            {{ scope.row.DealStatusName }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column width="150" label="操作">
        <template slot-scope="scope">
          <el-button
            type="button"
            @click.stop="onDetailItem(scope.row)"
            title="详情"
          >
            <i class="fas fa-eye"></i>
          </el-button>
          <el-button
            type="primary"
            @click.stop="onMiantainingClick(scope.row)"
            title="维修处理"
            v-if="scope.row.DealStatus === 4"
          >
            <i class="fas fa-wrench"></i>
          </el-button>
          <el-button
            type="danger"
            @click.stop="onBackClick(scope.row)"
            title="退回"
            v-if="scope.row.DealStatus === 4"
          >
            <i class="fas fa-share-square"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="clearfix mar-top-10">
      <el-pagination
        class="pull-right"
        @current-change="onChangePage"
        layout="total, prev, pager, next"
        :total="pager.total"
        :current-page="pager.page"
        :page-size="pager.size"
      >
      </el-pagination>
    </div>

    <detail-form v-model="item" :visible.sync="deltailVisible" :canEdit="true" />

    <maintaining-form
      v-model="item"
      :visible.sync="maintainingVisible"
      @form:saved="getItemList"
    />

    <back-form
      v-model="backItem"
      :visible.sync="backVisible"
      @form:saved="getItemList"
    />
  </el-card>
</template>

<script>
import DetailForm from "../maintainRegister/detail.vue"; //使用维修登记中的维修详情，公用
import MaintainingForm from "./maintianingForm.vue"; //提交维修处理
import BackForm from "./backForm.vue"; //退回确认维修

export default {
  components: {
    DetailForm,
    MaintainingForm,
    BackForm,
  },
  data() {
    return {
      itemList: [],
      loading: false,
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      former: {
        Type: "",
        DealPeopleID: "",
        DealStatus: "",
      },
      key: "",
      item: this.getEmptyItem(),
      backItem: this.getEmptyBackItem(),
      deltailVisible: false, //查看详情
      backVisible: false, //退回确认维修
      maintainingVisible: false, //确认维修处理
      curStatus: [],
    };
  },
  mounted() {
    this.getItemList();
  },
  created() {
    this.curStatus = [
      {
        Key: 4,
        Value: "维修中",
      },
    ];
  },
  methods: {
    getItemList() {
      this.loading = true;
      this.$axios
        .get("dci/maintain/maintain", {
          params: {
            where: this.former,
            with: [
              "DciProduct.DciProductModel",
              "DciAccessory.DciAccessoryModel",
              "MaintainUser",
              "SendPeople",
              "DealPeople",
            ],
            ...this.pager,
            key: this.key,
            order: ["deal_status", "-send_at"],
          },
        })
        .then((response) => {
          this.itemList = response.data.data;
          this.pager = _.pick(response.data, "size", "page", "total");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //维修详情
    onDetailItem(row) {
      this.item = row;
      this.deltailVisible = true;
    },
    getEmptyItem() {
      return {};
    },
    getEmptyBackItem() {
      return {
        ID: "", //维修id
        Type: 0, //维修类型
        InspectionItems: "", //检验项目
        MaintainUserID: this.$store.state.Auth.user.ID, //维修人员
        MaintainUser: [],
        ReasonAnalyse: "", //原因分析
        InspectionConclusion: "", //检验结论
        Grade: "", //不合格等级
        MaintainScheme: "", //维修方案
        ReplacementMode: 0, //更换方式 0:不更换 1:更换配件 2:更换整机
        BackDesc: "", //退回原因
      };
    },
    onSubmitQuery() {
      this.pager.page = 1;
      this.getItemList();
    },
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },

    //维修处理
    onMiantainingClick(row) {
      this.item = row;
      this.maintainingVisible = true;
    },

    //退回确认维修
    onBackClick(row) {
      this.backItem = this.getEmptyBackItem();
      this.backItem.ID = row.ID;
      this.backItem.Type = row.Type;
      this.backItem.InspectionItems = row.InspectionItems;
      this.backItem.MaintainUserID = row.MaintainUserID;
      this.backItem.MaintainUser = row.MaintainUser;
      this.backItem.ReasonAnalyse = row.ReasonAnalyse;
      this.backItem.InspectionConclusion = row.InspectionConclusion;
      this.backItem.Grade = row.Grade;
      this.backItem.MaintainScheme = row.MaintainScheme;
      this.backItem.ReplacementMode = row.ReplacementMode;
      this.backItem.BackDesc = row.BackDesc;
      this.backVisible = true;
    },
  },
};
</script>
